import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { useFetchCreds } from './hooks/fetchCreds'
import { type RootState } from './redux/rootReducer'

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isAuthenticated = useSelector((state: RootState) => state?.auth.isAuthenticated)
  const userId = useSelector((state: RootState) => state?.auth.userId)
  const user = useSelector((state: RootState) => state?.auth.user)
  const location = useLocation()
  const { fetchUserCredentials } = useFetchCreds()
  const initialRender = useRef(true)
  const [checkingSsoSession, setCheckingSsoSession] = useState(!userId)

  const fetchAuth = async (): Promise<void> => {
    await fetchUserCredentials(userId || null, user || null)
    initialRender.current = false
  }

  useEffect(() => {
    if (initialRender.current && !isAuthenticated) {
      fetchAuth().finally(() => setCheckingSsoSession(false))
    } else {
      initialRender.current = false
      setCheckingSsoSession(false)
    }
  }, [])

  if (checkingSsoSession && !userId) {
    return null
  }

  if (!userId || (!initialRender.current && !isAuthenticated)) {
    return <Navigate to='/' state={{ from: location }} replace />
  }
  return children
}

export default RequireAuth
